function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import axios from 'axios';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { API_PREFIX_URL, CACHE_KEYS } from './config';
var getCampaignResults = function() {
    var _ref = _async_to_generator(function(campaignIdentifier) {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios.get("".concat(API_PREFIX_URL, "/campaigns/").concat(campaignIdentifier, "/campaign_results"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getCampaignResults(campaignIdentifier) {
        return _ref.apply(this, arguments);
    };
}();
export var useCampaignResults = function(campaignIdentifier) {
    var refetchEnabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return useQuery([
        CACHE_KEYS.CAMPAIGN_RESULTS,
        campaignIdentifier
    ], function() {
        return getCampaignResults(campaignIdentifier);
    }, {
        enabled: !!campaignIdentifier,
        staleTime: refetchEnabled ? 1000 * 60 * 5 : Infinity,
        refetchOnWindowFocus: refetchEnabled
    });
};
var create = function() {
    var _ref = _async_to_generator(function(campaignIdentifier) {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios.post("/insights_platform/campaigns/".concat(campaignIdentifier, "/create_campaign_result"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function create(campaignIdentifier) {
        return _ref.apply(this, arguments);
    };
}();
/*
 *  Add share result
 */ export var useCreateCampaignResult = function(campaignIdentifier) {
    var queryClient = useQueryClient();
    return useMutation(function() {
        return create(campaignIdentifier);
    }, {
        onSuccess: function() {
            queryClient.invalidateQueries([
                CACHE_KEYS.CAMPAIGN_RESULTS,
                campaignIdentifier
            ]);
        }
    });
};
var destroy = function() {
    var _ref = _async_to_generator(function(campaignResultIdentifier) {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios.delete("/insights_platform/campaign_results/".concat(campaignResultIdentifier), {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function destroy(campaignResultIdentifier) {
        return _ref.apply(this, arguments);
    };
}();
/*
 *  Destroy share result
 */ export var useDestroyCampaignResult = function(campaignIdentifier) {
    var queryClient = useQueryClient();
    return useMutation(destroy, {
        onSuccess: function() {
            queryClient.invalidateQueries([
                CACHE_KEYS.CAMPAIGN_RESULTS,
                campaignIdentifier
            ]);
        }
    });
};
export var getResultsData = function() {
    var _ref = _async_to_generator(function(identifier) {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios.get("".concat(API_PREFIX_URL, "/campaigns/").concat(identifier, "/survey_results"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getResultsData(identifier) {
        return _ref.apply(this, arguments);
    };
}();
export var getCrossTabData = function() {
    var _ref = _async_to_generator(function(identifier, primaryQuestionId, secondaryQuestionId) {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios.get("".concat(API_PREFIX_URL, "/results/").concat(identifier, "/cross_tab_data?primary_question_id=").concat(primaryQuestionId, "&secondary_question_id=").concat(secondaryQuestionId))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getCrossTabData(identifier, primaryQuestionId, secondaryQuestionId) {
        return _ref.apply(this, arguments);
    };
}();
